/**
 * AI CONTEXT
 * Purpose: resolve a standout media storagePath to something an img or
 * audio element can load. An https value is used as-is. A bucket path goes
 * through getDownloadURLOrNull.
 * Used by: StandoutMomentContent, StandoutMomentCard.
 */
import * as Sentry from "@sentry/react"
import { useEffect, useState } from "react"

import Firestore from "#classes/Firestore"
import { directStandoutMediaUrl } from "#utils/standoutMediaUrl"

export const useStandoutMediaUrl = (
  storagePath: string | null | undefined
): string | null => {
  const [url, setUrl] = useState<string | null>(() =>
    directStandoutMediaUrl(storagePath)
  )

  useEffect(() => {
    const direct = directStandoutMediaUrl(storagePath)
    if (direct) {
      setUrl(direct)
      return
    }
    const path = storagePath?.trim()
    if (!path) {
      setUrl(null)
      return
    }
    let cancelled = false
    void Firestore.getInstance()
      .getDownloadURLOrNull(path)
      .then((next) => {
        if (!cancelled) setUrl(next)
      })
      .catch((error: unknown) => {
        if (!cancelled) Sentry.captureException(error)
      })
    return () => {
      cancelled = true
    }
  }, [storagePath])

  return url
}
